import { useEffect, useState } from "react";
import { Offcanvas, Row } from "react-bootstrap";
import {
  GET_ALL_MASTER_MERCHANT_PRIVILAGES,
  GET_USER_MANAGEMENT_DATA_BY_ID,
} from "../../../utils/constant";
import { getTokenFromLocalStorage } from "../../../utils/tokenService";
import { jwtDecode } from "jwt-decode";
import useApiServices from "../../../utils/useApiServices";

const ViewUser = ({ UserId, show, onHide }) => {
  const [userData, setUserData] = useState({});
  const [allPrivilegesWithSubTypes, setAllPrivilegesWithSubTypes] = useState([]);
  const [userPrivileges, setUserPrivileges] = useState([]);
  const token = getTokenFromLocalStorage();
  const decodedToken = typeof token === "string" ? jwtDecode(token) : {};
  const { masterId } = decodedToken;
  const { apiCallFnforGet } = useApiServices();
  const offcanvasStyle = { width: "90vw" };

  // -----------------------------------------
  // GET USER DATA
  // -----------------------------------------
  const getUserData = async () => {
    try {
      const response = await apiCallFnforGet(GET_USER_MANAGEMENT_DATA_BY_ID + UserId);
      if (response.statusCode === 200) {
        setUserData(response?.data);

        // extract sub privilege IDs
        const privIds = response?.data?.privilege?.map((p) =>
          String(p?.adminPrivilegeSubTypeId)
        );

        setUserPrivileges(privIds || []);
      } else {
        setUserData({});
        setUserPrivileges([]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // -----------------------------------------
  // GET ALL PRIVILEGES WITH SUB TYPES
  // -----------------------------------------
  const getAllMasterMerchantPrivilages = async () => {
    try {
      if (!masterId) return;
      const response = await apiCallFnforGet(GET_ALL_MASTER_MERCHANT_PRIVILAGES + masterId);
      if (response.statusCode === 200) {
        setAllPrivilegesWithSubTypes(response?.data || []);
      } else {
        setAllPrivilegesWithSubTypes([]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // -----------------------------------------
  // FETCH WHEN PANEL OPENS
  // -----------------------------------------
  useEffect(() => {
    if (!UserId || !show) return;
    const fetchData = async () => {
      await getAllMasterMerchantPrivilages();
      await getUserData();
    };
    fetchData();
  }, [UserId, show]);

  return (
    <>
      <Offcanvas
        show={show}
        onHide={onHide}
        placement="end"
        style={offcanvasStyle}
      >
        <div
          className="d-flex justify-content-start align-items-center mt-3"
          style={{ marginLeft: "28px" }}
        >
          <Offcanvas.Header closeButton />
          <h5 className="offcanvas-title fs-2 text-dark fw-bold">View User</h5>
        </div>

        <Offcanvas.Body>
          {/* --------------------- USER DETAILS ------------------------ */}
          <div className="card-body py-4">
            <div className="row">
              <div className="col-lg-6 mb-3">
                <label className="fs-3 text-dark">User Name</label>
                <div className="fs-5 text-dark">{userData?.name}</div>
              </div>

              <div className="col-lg-6 mb-3">
                <label className="fs-3 text-dark">e-Mail Id</label>
                <div className="fs-5 text-dark">{userData?.email}</div>
              </div>

              <div className="col-lg-6 mb-3">
                <label className="fs-3 text-dark">Mobile Number</label>
                <div className="fs-5 text-dark">{userData?.mobile}</div>
              </div>

              <div className="col-lg-6 mb-3">
                <label className="fs-3 text-dark">Password</label>
                <div className="fs-5 text-dark">{userData?.password}</div>
              </div>
            </div>
          </div>

          {/* --------------------- PRIVILEGES ------------------------ */}
          <div className="pt-4" style={{ borderTop: "1px solid #ccc" }}>
            <h4 className="fs-2">Privileges</h4>
          </div>

          <Row className="mt-3">
            <div className="d-flex flex-column gap-4">
              {allPrivilegesWithSubTypes?.map((group, index) => {
                // Subtypes the USER actually has
                const userOwnedSubTypes = group?.data?.subTypeDtoList?.filter((sub) =>
                  userPrivileges.includes(String(sub?.adminPrivilegeSubTypeId))
                );

                // Do NOT render this group if user has zero sub privileges
                if (userOwnedSubTypes?.length === 0) return null;

                return (
                  <div key={index} className="d-flex flex-column">
                    <h2 className="pt-2">{group?.data?.privilegeName}</h2>

                    <div className="row fs-4 mt-2 text-dark">
                      {userOwnedSubTypes?.map((sub, i) => (
                        <div
                          key={i}
                          className="checkbox-wrapper-27 col-lg-4 col-md-6 col-sm-12 d-flex"
                        >
                          <label className="checkbox">
                            <input
                              type="checkbox"
                              readOnly
                              checked={true}
                            />
                            <span className="checkbox__icon"></span>
                            {sub?.subTypePrivilegeName}
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>
                );
              })}
            </div>
          </Row>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default ViewUser;